import Vue from 'vue';
import Vuex from 'vuex';

// modules
import cart from './modules/cart.js';

Vue.use(Vuex);

const state = {};

export default new Vuex.Store({
  state,
  modules: {
    cart,
  },
});
